import { IconProps } from '../types/icon'

export const MapMarker = ({ fill = 'black' }: IconProps) => {
  return `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="10" fill="#D9D9D9" />
      <circle cx="20" cy="20" r="6" fill="${fill}" />
    </svg>`
}
